// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"MenuButton_btnTextStyle_10o8R"};